// Venipak + Omniva selector (Cart page + Cart drawer)
(function () {
  /*
   * Pickup point selector (Cart page + Cart drawer) — Venipak + Omniva
   *
   * Shopify Basic limitation: delivery/pickup method is chosen INSIDE CHECKOUT, not in cart.
   * Therefore this script runs in **soft mode**: it never blocks Checkout. We show a clear
   * disclaimer in the cart (Liquid) and simply save the selected point to
   * cart.attributes["pickup_point"] (+ pickup_carrier + pickup_point_id + pickup_point_country).
   *
   * Data sources:
   *  - Venipak: public API (CORS may fail) + theme asset JSON fallback
   *  - Omniva: theme asset JSON (recommended) + optional public endpoints (if you want)
   *
   * IMPORTANT:
   *  - Your Omniva file is: assets/omniva-points.json
   *  - In Liquid, set: data-omniva-asset-url="{{ 'omniva-points.json' | asset_url }}"
   *    If you don't add it, this script will try a best-effort fallback, but Liquid is safest.
   */

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  const root = $('#venipak-selector');
  if (!root) return;

  const selectedEl = $('#venipak-selected', root);
  const listEl = $('#venipak-list', root);
  const countryEl = $('#venipak-country', root);
  const searchEl = $('#venipak-search', root);
  const clearEl = $('#venipak-clear', root);

  // --- Tiny i18n (uses <html lang="..">) ---
  const _htmlLang = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  const _lang = (_htmlLang === 'et' ? 'ee' : _htmlLang); // treat 'et' as 'ee'
  const I18N = {
    en: {
      headerVenipak: 'Venipak pickup point',
      headerOmniva: 'Omniva parcel locker',
      carrier: 'Carrier',
      venipak: 'Venipak',
      omniva: 'Omniva',
      noSelected: 'No pickup point selected',
      noFound: 'No points found.',
      searchPH: 'Search by city or name…',
      clear: 'Clear'
    },
    lv: {
      headerVenipak: 'Venipak pakomāts',
      headerOmniva: 'Omniva pakomāts',
      carrier: 'Kurjers',
      venipak: 'Venipak',
      omniva: 'Omniva',
      noSelected: 'Nav izvēlēts pakomāts',
      noFound: 'Nav atrasti punkti.',
      searchPH: 'Meklēt pēc pilsētas vai nosaukuma…',
      clear: 'Notīrīt'
    },
    lt: {
      headerVenipak: 'Venipak paštomatas',
      headerOmniva: 'Omniva paštomatas',
      carrier: 'Vežėjas',
      venipak: 'Venipak',
      omniva: 'Omniva',
      noSelected: 'Nepasirinktas paštomatas',
      noFound: 'Taškų nerasta.',
      searchPH: 'Ieškoti pagal miestą ar pavadinimą…',
      clear: 'Išvalyti'
    },
    ee: {
      headerVenipak: 'Venipak pakiautomaat',
      headerOmniva: 'Omniva pakiautomaat',
      carrier: 'Vedaja',
      venipak: 'Venipak',
      omniva: 'Omniva',
      noSelected: 'Pakiautomaat pole valitud',
      noFound: 'Punkte ei leitud.',
      searchPH: 'Otsi linna või nime järgi…',
      clear: 'Tühjenda'
    }
  };
  const t = (k) => (I18N[_lang] && I18N[_lang][k]) || I18N.en[k] || k;

  // --- Carrier select (auto-inject if not present in Liquid) ---
  let carrierEl = $('#pickup-carrier', root);
  if (!carrierEl && countryEl) {
    // Create a minimal carrier dropdown and insert before country dropdown
    const wrap = document.createElement('div');
    wrap.style.cssText = 'margin:0 0 .5rem 0;display:flex;gap:.5rem;align-items:center;';

    const label = document.createElement('div');
    label.textContent = t('carrier') + ':';
    label.style.cssText = 'font-size:.9em;opacity:.85;white-space:nowrap;';

    carrierEl = document.createElement('select');
    carrierEl.id = 'pickup-carrier';
    carrierEl.style.cssText = 'flex:1;min-width:160px;padding:.55rem .6rem;border:1px solid #ddd;border-radius:.35rem;';

    const optV = document.createElement('option');
    optV.value = 'venipak';
    optV.textContent = t('venipak');

    const optO = document.createElement('option');
    optO.value = 'omniva';
    optO.textContent = t('omniva');

    carrierEl.appendChild(optV);
    carrierEl.appendChild(optO);

    wrap.appendChild(label);
    wrap.appendChild(carrierEl);

    // Insert above country/search row (best effort)
    const insertionPoint = countryEl.closest('.venipak-controls') || countryEl.parentElement || root;
    insertionPoint.insertBefore(wrap, insertionPoint.firstChild);
  }

  // --- Apply localized UI labels that are not rendered by Liquid ---
  function applyHeaderForCarrier(carrier) {
    try {
      const hdr = root.querySelector('.venipak-header strong');
      if (!hdr) return;
      hdr.textContent = (carrier === 'omniva') ? t('headerOmniva') : t('headerVenipak');
    } catch (e) {}
  }
  try {
    if (searchEl) searchEl.placeholder = t('searchPH');
    if (clearEl) clearEl.textContent = t('clear');
  } catch (e) {}

  // --- Read dataset urls ---
  // Venipak (keeps backwards compatibility with old dataset keys)
  const venipakRawApi = (root.dataset.apiUrl || root.dataset.venipakApiUrl || '').trim();
  const venipakApiUrl = venipakRawApi && venipakRawApi.toLowerCase() !== 'asset' ? venipakRawApi : '';
  const venipakAssetUrl = root.dataset.assetUrl || root.dataset.venipakAssetUrl || '';

  // Omniva
  const omnivaRawApi = (root.dataset.omnivaApiUrl || '').trim();
  const omnivaApiUrl = omnivaRawApi && omnivaRawApi.toLowerCase() !== 'asset' ? omnivaRawApi : '';
  let omnivaAssetUrl = root.dataset.omnivaAssetUrl || '';

  // Best-effort fallback if you didn't set data-omniva-asset-url in Liquid:
  // Try to guess from venipak asset URL by replacing "venipak" -> "omniva"
  if (!omnivaAssetUrl && venipakAssetUrl) {
    try {
      omnivaAssetUrl = venipakAssetUrl.replace(/venipak/gi, 'omniva');
    } catch (e) {}
  }

  const enabledCountries = {
    LV: root.dataset.enableLv === 'true',
    LT: root.dataset.enableLt === 'true',
    EE: root.dataset.enableEe === 'true'
  };

  let points = [];
  let selected = null; // {id,country,name,city,address,type}
  let carrier = (carrierEl && carrierEl.value) ? carrierEl.value : 'venipak';

  // --- pending row focus ---
  let _pendingFocusId = null;

  // === Map/List bridge (backwards compatible names) ===
  window.PickupSelectById = function (id) {
    try {
      if (!id) return false;
      const p = (points || []).find(x => String(x.id) === String(id));
      if (p) { selectPoint(p); return true; }
      _pendingFocusId = String(id);
    } catch (e) {}
    return false;
  };

  // old name kept
  window.VenipakSelectById = window.PickupSelectById;

  window.addEventListener('venipak:map-select', function (ev) {
    const id = ev && ev.detail && ev.detail.id;
    if (id) window.PickupSelectById(id);
  });
  window.addEventListener('pickup:map-select', function (ev) {
    const id = ev && ev.detail && ev.detail.id;
    if (id) window.PickupSelectById(id);
  });

  function escapeHTML(s) {
    const str = (s === null || s === undefined) ? '' : String(s);
    return str.replace(/[&<>'"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c]));
  }

  // Clean up Venipak display names (remove repetitive "Venipak locker," / "Venipak Pickup," prefixes)
  function formatDisplayName(p) {
    let name = String(p?.name || '').trim();

    // Only clean Venipak names; keep Omniva as-is
    if (carrier === 'venipak') {
      // Remove leading presets like: "Venipak locker, " or "Venipak Pickup, " (case-insensitive)
      name = name.replace(/^\s*venipak\s*(locker|pickup)\s*,\s*/i, '');

      // Also handle rare cases without comma: "Venipak locker " / "Venipak Pickup "
      name = name.replace(/^\s*venipak\s*(locker|pickup)\s+/i, '');

      // Normalize extra whitespace
      name = name.replace(/\s{2,}/g, ' ').trim();
    }

    return name;
  }

  // Normalize Venipak public API shape (https://go.venipak.lt/ws/get_pickup_points)
  function normalizeFromVenipakPublic(data) {
    const arr = Array.isArray(data) ? data
      : (Array.isArray(data?.points) ? data.points
      : (Array.isArray(data?.data) ? data.data : []));
    return arr.map(p => {
      const id = p.id || p.code || p.pickup_id || p.pup_id || p.pup_code || p.point_id || p.pickupPointId || '';
      const country = (p.country || p.country_code || p.cc || p.Country || '').toString().toUpperCase();
      const name = p.name || p.title || p.point_name || p.Name || '';
      const city = p.city || p.town || p.City || '';
      const address = p.address || p.street || p.Address || p.location || '';
      let type = (p.type || p.pick_up_type || p.PickUpType || '').toString().toLowerCase();
      if (!type && (p.type_id || p.pick_up_type_id)) {
        const t = String(p.type_id || p.pick_up_type_id);
        type = (t === '3') ? 'locker' : (t === '1' ? 'pickup' : '');
      }
      if (!type && /pakom|locker|pakomat/i.test((name || '') + ' ' + (p.description || ''))) type = 'locker';
      return { id, country, name, city, address, type };
    }).filter(x => x.id && x.country && x.name);
  }

  // Normalize Omniva locations JSON (your omniva-points.json)
  function normalizeFromOmniva(data) {
    const arr = Array.isArray(data) ? data
      : (Array.isArray(data?.locations) ? data.locations
      : (Array.isArray(data?.data) ? data.data : []));

    return arr.map(p => {
      // In Omniva locations.json, country is usually A0_NAME (EE/LV/LT)
      const country = String(p.A0_NAME || p.country || p.country_code || p.cc || '').toUpperCase();

      // Name + city + address commonly in NAME/A1_NAME/A2_NAME
      const name = p.NAME || p.name || p.title || p.pup_name || '';
      const city = p.A1_NAME || p.city || p.town || '';
      const address = p.A2_NAME || p.address || p.street || p.ADDRESS || '';

      // ID: ZIP is common in Omniva list, also sometimes "ID"
      const id = String(p.ZIP || p.zip || p.ID || p.id || p.code || p.PARCEL_MACHINE_ID || p.PM_ID || '').trim();

      // Type hint
      const rawType = String(p.TYPE || p.type || p.category || '').toLowerCase();
      let type = rawType;
      // Heuristics: treat parcel machines as "locker"
      if (!type && /pack|parcel|auto|locker|pakom|pašt|pakiaut/i.test((name || '') + ' ' + (p.DESCRIPTION || p.description || ''))) {
        type = 'locker';
      }
      // Some Omniva entries may have "APT" (post office) etc — keep them unless you want lockers only

      return { id, country, name, city, address, type };
    }).filter(x => x.id && x.country && x.name);
  }

  // Ensure a country parameter exists on a URL if not already provided
  function appendCountryParam(url, cc) {
    try {
      if (!cc) return url;
      const u = new URL(url, location.origin);
      if (!u.searchParams.get('country')) u.searchParams.set('country', cc);
      return u.toString();
    } catch (e) { return url; }
  }

  // Small helper: fetch JSON with a short timeout (so CORS/API failures don't stall UI)
  function fetchJSONWithTimeout(url, opts = {}, timeoutMs = 1800) {
    return new Promise((resolve, reject) => {
      let done = false;
      const tmr = setTimeout(() => { if (!done) { done = true; reject(new Error('timeout')); } }, timeoutMs);
      fetch(url, opts)
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(json => { if (!done) { done = true; clearTimeout(tmr); resolve(json); } })
        .catch(err => { if (!done) { done = true; clearTimeout(tmr); reject(err); } });
    });
  }

  function getSourceForCarrier() {
    if (carrier === 'omniva') {
      return { kind: 'omniva', apiUrl: omnivaApiUrl, assetUrl: omnivaAssetUrl };
    }
    return { kind: 'venipak', apiUrl: venipakApiUrl, assetUrl: venipakAssetUrl };
  }

  function fetchPoints() {
    const cc = (countryEl && countryEl.value) ? countryEl.value.toUpperCase() : '';
    const src = getSourceForCarrier();

    const isAssetPlaceholder = (v) => !v || /^\s*$/.test(v) || /^asset$/i.test(String(v).trim());

    // Defaults:
    const venipakPublicBase = 'https://go.venipak.lt/ws/get_pickup_points';
    const venipakPublicUrl = `${venipakPublicBase}?pick_up_type=1,3&view=json${cc ? `&country=${cc}` : ''}`;

    // Omniva public endpoint (optional). If you want only your theme file, keep apiUrl empty and it will use asset.
    const omnivaPublicUrl = 'https://www.omniva.ee/locations.json';

    const apiCandidate =
      (src.kind === 'venipak')
        ? (!isAssetPlaceholder(src.apiUrl) ? appendCountryParam(src.apiUrl, cc) : venipakPublicUrl)
        : (!isAssetPlaceholder(src.apiUrl) ? src.apiUrl : omnivaPublicUrl);

    const apiTry = fetchJSONWithTimeout(apiCandidate, { cache: 'no-store', mode: 'cors' }, 1800)
      .then(json => {
        console.info(`[${src.kind}] Using API:`, apiCandidate);
        const norm = (src.kind === 'venipak') ? normalizeFromVenipakPublic(json) : normalizeFromOmniva(json);
        return cc ? norm.filter(x => x.country === cc) : norm;
      })
      .catch(() => null);

    const assetTry = src.assetUrl
      ? fetchJSONWithTimeout(src.assetUrl, { cache: 'no-store' }, 4000)
          .then(json => {
            console.info(`[${src.kind}] Using theme asset JSON:`, src.assetUrl);
            const norm = (src.kind === 'venipak')
              ? (Array.isArray(json) ? json : normalizeFromVenipakPublic(json))
              : (Array.isArray(json) ? json : normalizeFromOmniva(json));
            return cc ? norm.filter(x => x.country === cc) : norm;
          })
          .catch(() => [])
      : Promise.resolve([]);

    // Return whichever resolves first with usable data; otherwise fall back to asset.
    return apiTry.then(data => (data && data.length ? data : Promise.reject()))
      .catch(() => assetTry)
      .then(arr => Array.isArray(arr) ? arr : []);
  }

  // Delegate clicks/keys to list container (stable across re-renders)
  if (listEl) {
    listEl.addEventListener('click', function (e) {
      const row = e.target.closest('[data-point-id]');
      if (!row) return;
      const id = row.getAttribute('data-point-id');
      const p = (points || []).find(x => String(x.id) === String(id));
      if (p) selectPoint(p);
    }, true);

    listEl.addEventListener('keydown', function (e) {
      const row = e.target.closest('[data-point-id]');
      if (!row) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const id = row.getAttribute('data-point-id');
        const p = (points || []).find(x => String(x.id) === String(id));
        if (p) selectPoint(p);
      }
    }, true);
  }

  function _focusListRowById(id) {
    try {
      if (!id || !listEl) return;
      const row = listEl.querySelector(`[data-point-id="${CSS.escape(String(id))}"]`);
      if (!row) { _pendingFocusId = String(id); return; }
      row.classList.add('is-selected');
      row.setAttribute('aria-pressed', 'true');
      try { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
      try { row.focus({ preventScroll: true }); } catch (_) {}
      row.classList.add('just-selected');
      setTimeout(() => { try { row.classList.remove('just-selected'); } catch (_) {} }, 1200);
      _pendingFocusId = null;
    } catch (e) {}
  }

  function renderList() {
    const q = String(searchEl && searchEl.value ? searchEl.value : '').toLowerCase();
    const cc = countryEl.value;
    const filtered = points.filter(p =>
      p.country === cc &&
      (!q || (p.city || '').toLowerCase().includes(q) || (p.name || '').toLowerCase().includes(q))
    );

    listEl.innerHTML = filtered.length ? '' : '<div style="padding:.75rem;">' + escapeHTML(t('noFound')) + '</div>';

    for (const p of filtered) {
      const row = document.createElement('div');
      row.setAttribute('role', 'button');
      row.setAttribute('tabindex', '0');
      row.setAttribute('data-point-id', String(p.id || ''));
      row.className = 'venipak-row';
      row.style.cssText = 'width:100%;text-align:left;padding:.6rem .75rem;border-bottom:1px solid #eee;display:block;cursor:pointer;';

      const safeName = escapeHTML(formatDisplayName(p));
      const safeCity = escapeHTML(p.city);
      const safeAddr = escapeHTML(p.address);
      const typeTxt = p.type ? ` · ${escapeHTML(p.type)}` : '';

      row.innerHTML = `
        <div style="font-weight:600;">${safeName}</div>
        <div style="font-size:.9em;opacity:.85;">${safeCity}${safeCity && safeAddr ? ', ' : (safeAddr ? '' : '')}${safeAddr}${typeTxt}</div>
      `;

      if (selected && selected.id && String(selected.id) === String(p.id)) {
        row.classList.add('is-selected');
        row.setAttribute('aria-pressed', 'true');
        row.style.background = '#fef7dd';
      } else {
        row.setAttribute('aria-pressed', 'false');
      }

      row.addEventListener('click', () => selectPoint(p));
      row.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPoint(p); } });

      listEl.appendChild(row);
    }

    if (_pendingFocusId) _focusListRowById(_pendingFocusId);
  }

  function setSelectedText(p) {
    selected = p || null;
    selectedEl.textContent = p
      ? `${formatDisplayName(p)} - ${[p.city, p.address].filter(Boolean).join(', ')} (${p.country})`
      : t('noSelected');
  }

  function selectPoint(p) {
    setSelectedText(p);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          pickup_carrier: carrier,
          pickup_point: `[${p.country}] ${formatDisplayName(p)} - ${[p.city, p.address].filter(Boolean).join(', ')}`,
          pickup_point_country: p.country,
          pickup_point_id: String(p.id || '')
        }
      })
    })
      .then(() => {
        enforceCheckoutGuard();

        // Notify map (optional)
        try { window.dispatchEvent(new CustomEvent('pickup:selected', { detail: { carrier, point: p } })); } catch (e) {}
        try { window.dispatchEvent(new CustomEvent('venipak:selected', { detail: { point: p } })); } catch (e) {} // backward compat

        try {
          renderList();
          _focusListRowById(p.id);
        } catch (e) {}
      })
      .catch(console.error);
  }

  function loadExisting() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const attrs = cart.attributes || {};

        // Restore carrier if saved
        const savedCarrier = (attrs.pickup_carrier || '').toString().toLowerCase();
        if (savedCarrier === 'omniva' || savedCarrier === 'venipak') {
          carrier = savedCarrier;
          if (carrierEl) carrierEl.value = carrier;
        }
        applyHeaderForCarrier(carrier);

        const ppId = attrs.pickup_point_id ? String(attrs.pickup_point_id) : '';
        if (ppId && Array.isArray(points) && points.length) {
          const match = points.find(x => String(x.id) === ppId);
          if (match) {
            setSelectedText(match);
            renderList();
            enforceCheckoutGuard(cart);
            _focusListRowById(ppId);
            return;
          }
          _pendingFocusId = ppId;
        }

        const pp = attrs.pickup_point;
        if (pp) setSelectedText({ id: attrs.pickup_point_id || '', name: pp, city: '', address: '', country: attrs.pickup_point_country || '' });
        else setSelectedText(null);

        enforceCheckoutGuard(cart);
        renderList();
      });
  }

  // Soft guard: never block Checkout from cart; we only show the disclaimer in Liquid.
  function enforceCheckoutGuard() {
    try {
      const targets = [
        'form[action="/cart"] [name="checkout"]',
        '.cart-drawer [name="checkout"]',
        'button[name="checkout"]',
        'a[href$="/checkout"]'
      ];
      const btns = Array.from(document.querySelectorAll(targets.join(',')));
      btns.forEach(btn => {
        if (!btn) return;
        btn.disabled = false;
        btn.classList.remove('is-disabled', 'disabled');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-venipak-locked');
        btn.title = '';
      });
    } catch (e) {}
  }

  // Ensure older hard-guards can't block Checkout: allow the click to flow.
  document.addEventListener('click', function (e) {
    const tEl = e.target && e.target.closest && e.target.closest('button[name="checkout"], a[href*="/checkout"]');
    if (!tEl) return;
    try { e.stopImmediatePropagation(); } catch (_) {}
  }, true);

  function hideDynamicCheckout() { // force customers through cart
    $$('.shopify-payment-button, .additional-checkout-buttons').forEach(el => el.style.display = 'none');
  }

  clearEl?.addEventListener('click', (e) => {
    e.preventDefault();
    try { searchEl.value = ''; } catch (e) {}

    setSelectedText(null);
    _pendingFocusId = null;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          pickup_carrier: carrier, // keep current carrier
          pickup_point: '',
          pickup_point_country: '',
          pickup_point_id: ''
        }
      })
    })
      .then(() => {
        renderList();
        enforceCheckoutGuard();
      })
      .catch(() => {
        renderList();
        enforceCheckoutGuard();
      });
  });

  function debounce(fn, ms) { let tmr; return (...a) => { clearTimeout(tmr); tmr = setTimeout(() => fn.apply(null, a), ms); }; }
  const renderListDebounced = debounce(renderList, 120);

  searchEl?.addEventListener('input', renderListDebounced);

  countryEl?.addEventListener('change', () => {
    setSelectedText(null);
    _pendingFocusId = null;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          pickup_carrier: carrier,
          pickup_point: '',
          pickup_point_country: '',
          pickup_point_id: ''
        }
      })
    }).finally(() => {
      fetchPoints()
        .then(d => { points = Array.isArray(d) ? d : (d?.points || []); renderList(); enforceCheckoutGuard(); })
        .catch(() => { renderList(); enforceCheckoutGuard(); });
    });
  });

  carrierEl?.addEventListener('change', () => {
    carrier = carrierEl.value || 'venipak';
    applyHeaderForCarrier(carrier);

    setSelectedText(null);
    _pendingFocusId = null;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          pickup_carrier: carrier,
          pickup_point: '',
          pickup_point_country: '',
          pickup_point_id: ''
        }
      })
    }).finally(() => {
      fetchPoints()
        .then(d => { points = Array.isArray(d) ? d : (d?.points || []); renderList(); enforceCheckoutGuard(); })
        .catch(() => { renderList(); enforceCheckoutGuard(); });
    });
  });

  // Init
  hideDynamicCheckout();
  applyHeaderForCarrier(carrier);

  fetchPoints()
    .then(d => { points = Array.isArray(d) ? d : (d?.points || []); })
    .then(() => loadExisting())
    .then(() => renderList())
    .catch(e => console.error('Pickup points load error', e));

  new MutationObserver(() => enforceCheckoutGuard()).observe(document.body, { attributes: true });

  // Styles
  try {
    if (!document.getElementById('venipak-inline-style')) {
      const st = document.createElement('style');
      st.id = 'venipak-inline-style';
      st.textContent = [
        '.venipak-selector .button--warning{background:#f59e0b;color:#fff}',
        '#venipak-list{position:relative;z-index:2;pointer-events:auto;}',
        '.venipak-row{cursor:pointer;outline:0;}',
        '.venipak-row:hover,.venipak-row:focus{background:#fafafa;}',
        '.venipak-row.is-selected{background:#fef7dd;}',
        '.venipak-row.just-selected{animation:venipakPulse 1.2s ease 1;}',
        '@keyframes venipakPulse{0%{box-shadow:0 0 0 0 rgba(245,158,11,.0);}30%{box-shadow:0 0 0 6px rgba(245,158,11,.25);}100%{box-shadow:0 0 0 0 rgba(245,158,11,.0);}}'
      ].join('\n');
      document.head.appendChild(st);
    }
  } catch (e) {}
})();